/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const createDetailsTabStyles = makeStyles(() => ({
  descriptionContainer: {
    maxWidth: '686px',
    marginBottom: '32px',
  },
  descriptionTitle: {
    marginBottom: '10px',
  },
  description: {
    color: '#000000',
    maxWidth: '654px',
    lineHeight: '20px',
  },
  detailsContainer: {
    marginBottom: '42px',
  },
  detailsTitle: {
    marginBottom: '10px',
  },
  detailsRow: {
    '&:not(:last-child)': {
      marginBottom: '8px',
    },
  },
  detailsKey: {
    marginRight: '8px',
    color: '#A2A7AE',
    lineHeight: '20px',
  },
  detailsValue: {
    // color: '#000000',
    lineHeight: '20px',
  },
  replicasWrapper: {
    marginBottom: '34px',
  },
  replicasSlider: {
    width: '480px',
  },
  replicasMarkLabel: {
    zIndex: 2,
  },
  replicasInitThumb: {
    position: 'relative',
    margin: '0',
    fontWeight: 'bold',
    color: '#1F3F6D',
  },
  replicasInitThumbMark: {
    top: '-15px',
    position: 'absolute',
    border: '3px solid #35527C',
    borderRadius: '50%',
  },
  replicasContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
  },
  submitButton: {
    minWidth: '120px',
    marginLeft: '8px',
    padding: '13px 0',
  },
  submitButtonLink: {
    color: '#F16623',
  },
  allowedSourceRangesWrapper: {
    marginBottom: '20px',
  },
  spinner: {
    display: 'inline-flex',
  },
  storageError: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  storageErrorTitle: {
    lineHeight: '20px',
  },
  infoIcon: {
    marginLeft: '8px',
    width: '24px',
    height: '24px',
    padding: '0',
  },
  tooltip: {
    maxWidth: 'none',
  },
  iconButton: {
    padding: '0',
    transform: 'rotate(-90deg)',
    color: '#A2A7AE',
  },
  iconButtonReverse: {
    transform: 'rotate(90deg)',
  },
  addressRow: {
    display: 'flex',
    alignItems: 'center',
  },
  address: {
    display: 'inline-flex',
    backgroundColor: 'rgba(162,167,174, .1)',
    padding: '2px 5px',
    borderRadius: '3px',
    color: '#000000',
    fontFamily: 'Apercu Mono',
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.09px',
  },
}));

export { createDetailsTabStyles };
